import { types } from "../../types/types";

const initialState = {
  items: [],
  horarios: [],
  itemsDemanda: [],
  especialidadesDemanda: [],
  cargada: false,
  loading: false,
  seleccionado: null,
  disabled: true,
  error: null

};

export const efectorHorariosReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.efectorHorariosTraerStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.efectorHorariosTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.efectorHorariosDemandaTraerSuccess:
      return {
        ...state,
        loading: false,
        itemsDemanda: action.payload,
        cargada: true,
      };  
    case types.efectorHorariosTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        itemsDemanda: [],
        especialidadesDemanda: [],
        cargada: false,
      };
    case types.efectorHorariosLimpiar:
      return {
        ...state,
        loading: false,
        items: [],
        itemsDemanda: [],
        especialidadesDemanda: [],
        cargada: false,
      };
    case types.especialidadesHorarioDemandaTraerSuccess:
      return {
        ...state,
        loading: false,
        especialidadesDemanda: action.payload,
        cargada: true,
      };  
    case types.efectorHorarioSeleccionar:
      return {
        ...state,
        loading: false,
        seleccionado: action.payload,
        cargada: true,
      };
    case types.efectorHorariosUpdateDisabled:
      return {
        ...state,
        disabled: action.payload,
      };
    case types.efectorHorariosModificarInHabilitado:
      return {
        ...state,
        items: state.items.map( item => item.idEfHorario === action.payload.idEfHorario
          ? {...item, inHabilitado: action.payload.inHabilitado} 
          : item
        ),
      };
    case types.efectorHorariosInHabilitarGenerar:
      return {
        ...state,
        items: state.items.map( item => item.idEfHorario === action.payload
          ? {...item, generacionInicial: true} 
          : item
        ),
      };
    case types.horariosMedicosTraerSuccess:
      return {
        ...state,
        loading: false,
        horarios: action.payload,
        cargada: true,
      };
    case types.horariosMedicosTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        horarios: [],
        cargada: false,
      };
    default:
      return state;
  }
};
